import { apiAuth, apiResponseType } from ".";

export const getTimeEntryMirrorData = (params?: {
  page?: number;
  unity_id?: string;
  status?: number;
}): apiResponseType => {
  const searchParams = new URLSearchParams();
  if (params?.page) searchParams.append("page", String(params.page));
  if (params?.unity_id) searchParams.append("unity_id", String(params.unity_id));
  if (params?.status) searchParams.append("status", String(params.status));
  return apiAuth.get(`time-entry-mirror?${searchParams.toString()}`);
};

export const generateTimeEntryMirror = (data: {
  date_start: string;
  date_end: string;
  unity_id?: number;
  employee_id?: number;
}): apiResponseType => apiAuth.post("time-entry-mirror", data);

export const getShowTimeEntryMirror = (uuid: string): apiResponseType =>
  apiAuth.get(`time-entry-mirror/${uuid}/show`);

export const reprocessTimeEntryMirror = (uuid: string): apiResponseType =>
  apiAuth.post(`time-entry-mirror/${uuid}/reprocess`);

export const deleteTimeEntryMirror = (uuid: string): apiResponseType =>
  apiAuth.delete(`time-entry-mirror/${uuid}/destroy`);

export const getTimeEntryMirrorEmployeeReportDownloadUrl = (
  uuid: string,
  employeeReportUuid: string
): apiResponseType =>
  apiAuth.get(`time-entry-mirror/${uuid}/employee-report/${employeeReportUuid}/download`);

export const getMyTimeEntryMirrorReports = (page: number = 1): apiResponseType =>
  apiAuth.get(`time-entry-mirror/my-reports?page=${page}`);

export const getMyTimeEntryMirrorReportDownloadUrl = (
  employeeReportUuid: string
): apiResponseType =>
  apiAuth.get(`time-entry-mirror/my-reports/${employeeReportUuid}/download`);

export const signMyTimeEntryMirrorReport = (
  employeeReportUuid: string
): apiResponseType =>
  apiAuth.put(`time-entry-mirror/my-reports/${employeeReportUuid}/sign`);
